import type { JVSIcons } from '@mairistem/composants';
import { type Mouvement, Sens } from '@mairistem/comptabilite';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';

const getMouvementIcon = (mouvement: Mouvement) => {
	let iconName: JVSIcons = 'FileQuestion';

	if (mouvement.datePcePec) {
		iconName = 'FileCheck2';
	} else if (mouvement.datePceRej) {
		iconName = 'FileX2';
	} else if (mouvement.datePceInst) {
		iconName = 'FileClock';
	}

	return (
		<Icon
			iconSet="Lucide"
			name={iconName}
			color={mouvement.sens === Sens.DEPENSE ? '#7a3030' : '#476d4e'}
		/>
	);
};

export default getMouvementIcon;
